<div class="col-md-6 offset-md-3">
    <div class="container" style="margin-top: 50px;">
        <br>
        <article class="card-shadow card-body mx-auto" style="max-width: 350px;">
            <h4 class="card-title mt-3 text-center">Create Account</h4>
            <div>
                <button type="button" (click)="loginWithGoogle()" class="btn btn-primary" style="width: 100%;"><img src="https://img.icons8.com/plasticine/100/000000/google-logo.png" style="height: 30px; width: 30px; margin-right: 20px;"/>Continue with Google</button>
            </div>
            <p class="divider-text">
                <span class="bg-light" style="border-radius: 25px;">OR</span>
            </p>
            <form [formGroup]="loginForm">

                <div class="form-group input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text"> <i class="fa fa-envelope"></i> </span>
                    </div>
                    <input formControlName="email" name="" class="form-control" id="exampleInputEmail1"
                        placeholder="Email" type="email">
                    <span class="input-group-append bg-white" *ngIf="email.invalid && email.touched">
                        <button class="btn border" type="button"><i class="fa fa-info-circle" data-toggle="tooltip"
                                title={{info.email}}></i></button>
                    </span>
                </div>

                <!-- form-group// -->
                <div class="form-group input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text"> <i class="fa fa-lock"></i> </span>
                    </div>
                    <input formControlName="pass" id="passwordInput" class="form-control" placeholder="password"
                        type="password">
                    <span class="input-group-append bg-white" *ngIf="pass.invalid && pass.touched">
                        <button class="btn border" type="button"><i class="fa fa-info-circle" data-toggle="tooltip"
                                title={{info.passinfo}}></i></button>
                    </span>
                    <!-- <span >Email is Required</span><br> -->

                </div>

                <!-- form-group// -->
                <div class="form-group">
                    <button type="submit" class="btn btn-primary btn-block" [disabled]='loginForm.invalid'
                        (click)="login()">
                        Login
                    </button>
                </div>
                <p class="text-center">New User? <a (click)="moveToRegister()"
                        style="color: blue; cursor:pointer; "><u>Register</u></a> </p> <!-- form-group// -->
            </form>
        </article>
        <br>
    </div>
</div>